export default {
  namespaced: true,
  state: () => ({
    items: [],
    latest: {},
  }),
  actions: {},
};
